import { useState, useEffect, useMemo } from "react";
import { iconNoProduct } from "assets";
import { Service } from "utils/services";

type ImageUrlProps = {
  src: string;
  alt?: string;
} & React.ImgHTMLAttributes<HTMLImageElement>;

export default function ImageUrl1({ src, alt = "", ...props }: ImageUrlProps) {
  const imageSrc = useMemo(() => {
    if (!src || src === "") return iconNoProduct;
    return Service.applicationMode.isDebug() ? src.replace("https", "http") : src;
  }, [src]);

  return (
    <img
      {...props}
      src={imageSrc}
      onError={(e) => {
        e.currentTarget.src = iconNoProduct;
      }}
      alt={alt}
    />
  );
}
